import WebFont from 'webfontloader';
import { Fonts as CoreFonts } from '@vds-core/typography'; //****** To-do, test loading in the families first asynchronously from check whether to load the url if necessary ******//

var FontConfig = {
  loaded: false
}; //Turn on or off the font loader

function setFontLoaded(loaded) {
  FontConfig.loaded = loaded ? true : false;
  CoreFonts.setFontLoaded && CoreFonts.setFontLoaded(loaded);
}

function checkFontLoaded() {
  return FontConfig.loaded;
} // Define and Load the fonts


var customConfig = {
  families: ['BrandFont-Text', 'BrandFont-Display']
};
var fontUri = 'https://respframework.verizon.com/fonts/v2/fonts-update.css';

function finishLoading(customConfig) {
  var WebFontConfig = {
    custom: customConfig
  };
  WebFont.load(WebFontConfig);
}

function checkIfLoaded(sheetsArray) {
  return new Promise(function (resolve, reject) {
    var objThere = sheetsArray && sheetsArray.find(function (obj) {
      //New font file is in the <head>
      if (obj && obj.href && obj.href.indexOf('respframework.verizon.com/fonts/v2/fonts-update') > -1) {
        return true; //Old font file is in the <head>
      } else if (obj && obj.href && obj.href.indexOf('respframework.verizon.com/fonts/v2/fonts.css') > -1) {
        return true; //Okay load the font, I guess we dont have it yet
      } else {
        return false;
      }
    });
    resolve(objThere);
  });
}

function loadFonts(loaded) {
  var headTag = document.documentElement && document.documentElement.outerHTML;
  var fontActive = (headTag.indexOf('brandfonttext') > -1 || headTag.indexOf('brandfontdisplay') > -1) && headTag.indexOf('wf-active') > -1; //If the font was configured not to reload, dont reload it just provide the font families

  if (FontConfig && FontConfig.loaded || loaded) {
    if (fontActive) return;
    finishLoading(customConfig); //If the font loader was not turned off, still check if its present in the <head> before loading again
  } else {
    var sheetRefs = document.styleSheets,
        sheetArray = sheetRefs && Object.values(sheetRefs);

    if (!fontActive) {
      //Double check in case the head tag is being wiped programmatically
      checkIfLoaded(sheetArray).then(function (exists) {
        if (!exists) customConfig.urls = [fontUri];
        finishLoading(customConfig);
      });
    } else {
      return;
    }
  }
}

if (!FontConfig.loaded) {
  CoreFonts.setFontLoaded && CoreFonts.setFontLoaded(true);
  loadFonts();
}

export var Fonts = {
  NeueHaasGroteskText: 'BrandFont-Text',
  // BAU - Text Normal
  NeueHaasGroteskDisplay: 'BrandFont-Display',
  // BAU - Text Display,
  checkFontLoaded: checkFontLoaded,
  setFontLoaded: setFontLoaded,
  loadFonts: loadFonts
};